// extracted by mini-css-extract-plugin
export default {"additionalLink":"AdditionalLink_additionalLink__WQ4zM","description":"AdditionalLink_description__CJzMk","link":"AdditionalLink_link__CDsqR"};